import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"
import { cn } from "@/lib/utils"

const labelVariants = cva(
  "inline-flex items-center justify-center px-[5px] py-[1px] rounded-[5px] text-xs font-medium leading-[16px] whitespace-nowrap",
  {
    variants: {
      variant: {
        default: "bg-[#354267] text-white",
        // 案件ステータス
        vendor: "bg-[#ddf6ff] text-[#3f4652]",
        oc: "bg-[#ffe3cd] text-[#3f4652]",
        owner: "bg-[#f9f7db] text-[#3f4652]",
        completed: "bg-slate-200 text-[#3f4652]",
        // 承認ステータス
        unapproved: "bg-slate-200 text-slate-500",
        approved: "bg-[#354267] text-white",
        rejected: "bg-[#ff3232] text-white",
        // プラン
        plusPlan: "bg-[#354267] text-white",
        standardPlan: "bg-[#dce5ff] text-[#354267]",
        echoesPlan: "bg-[#e6f4ea] text-[#1e6b3a]",
        planSuspended: "bg-yellow-100 text-yellow-800",
        nonePlan: "bg-slate-200 text-slate-400",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface LabelProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof labelVariants> {}

const Label = React.forwardRef<HTMLDivElement, LabelProps>(
  ({ className, variant, children, ...props }, ref) => {
    return (
      <div ref={ref} className={cn(labelVariants({ variant }), className)} {...props}>
        {children}
      </div>
    )
  }
)
Label.displayName = "Label"

export { Label, labelVariants }
